import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { connect } from 'react-redux';
import { Bar } from 'react-chartjs-2';
import { makeStyles, FormControl, Select, MenuItem, Grid, Typography, Divider } from '@material-ui/core';

import Tab from 'src/components/tab';
import ChartLegend from 'src/components/chartLegend';
import ChartWrapper from 'src/components/chartWrapper';
import TooltipedText from 'src/components/tooltipedText';

import { coloredDatasets } from 'src/helpers/chartJsHelpers';

import { setTabExpend, setDate } from './slice';

const data = coloredDatasets('bar', {
  labels: ['Monday', 'Tuesday', ' Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  datasets: [
    {
      label: 'Leads posted',
      data: [12, 19, 3, 5, 3, 5, 2],
      borderWidth: 0,
    },
    {
      label: 'Leads called',
      data: [12, 19, 3, 5, 3, 5, 2],
      borderWidth: 0,
    },
    {
      label: 'Calls connected',
      data: [12, 19, 3, 5, 3, 5, 2],
      borderWidth: 0,
    },
    {
      label: 'Calls tagged',
      data: [12, 19, 3, 5, 3, 5, 2],
      borderWidth: 0,
    },
  ],
});

const options = {
  maintainAspectRatio: false,
  cornerRadius: 10,
  fullCornerRadius: false,
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          stepSize: 5,
          padding: 20,
        },
        gridLines: {
          drawTicks: false,
          drawBorder: false,
        },
      },
    ],
    xAxes: [
      {
        ticks: {
          beginAtZero: true,
          padding: 20,
        },
        gridLines: {
          display: false,
        },
        categoryPercentage: 0.5,
        barPercentage: 0.4,
      },
    ],
  },
  legend: {
    display: false,
  },
};

const legend = ['Leads Posted', 'Leads Called', 'Calls Connected', 'Calls Tagged'];

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 125,
    [theme.breakpoints.up('lg')]: {
      position: 'absolute',
    },
  },
  infoWrapper: {
    maxWidth: 700,
    margin: 'auto',
    '& > *': {
      paddingTop: theme.spacing(2),
    },
    '& > *:not(:last-child)': {
      borderRight: '1px solid #EAEDF3',
    },
    [theme.breakpoints.down('sm')]: {
      '& > *:nth-child(1)': {
        borderBottom: '1px solid #EAEDF3',
      },
      '& > *:nth-child(2)': {
        borderRight: 'none',
        borderBottom: '1px solid #EAEDF3',
      },
    },
  },
  text: {
    justifyContent: 'center',
  },
}));

const Performance = props => {
  const { isTabExpended, date } = props;
  const classes = useStyles();

  const prismicContent = useStaticQuery(graphql`
    query {
      allPrismicOverview {
        edges {
          node {
            data {
              title2 {
                html
                text
                raw
              }
              tooltip2a {
                html
                text
                raw
              }
              tooltip2b {
                html
                text
                raw
              }
              tooltip2c {
                html
                text
                raw
              }
              tooltip2d {
                html
                text
                raw
              }
            }
          }
        }
      }
    }
  `);

  const prismicData = prismicContent.allPrismicOverview.edges[0].node.data;

  const handelExpand = () => {
    props.setTabExpend(!isTabExpended);
  };

  const handelChange = event => {
    props.setDate(event.target.value);
  };

  return (
    <Tab title={prismicData.title2.text} TooltipedText="" drag onClick={handelExpand} expanded={isTabExpended}>
      <div>
        {/* <FormControl variant="outlined" color="secondary" size="small" className={classes.formControl}>
          <Select value={date} onChange={handelChange}>
            <MenuItem value="year">Year</MenuItem>
            <MenuItem value="month">Month</MenuItem>
            <MenuItem value="week">Week</MenuItem>
          </Select>
        </FormControl> */}
        <ChartLegend legend={legend} maxWidth={600} />
      </div>
      <ChartWrapper>
        <Bar data={data} options={options} height={300} />
      </ChartWrapper>
      <Grid container className={classes.infoWrapper}>
        <Grid item xs={6} md>
          <TooltipedText gutterBottom={1} tooltipText={prismicData.tooltip2a.text} position="center">
            <Typography variant="body2" align="center">
              Leads Posted
            </Typography>
          </TooltipedText>
          <Typography variant="h5" align="center" gutterBottom>
            150
          </Typography>
          <Typography variant="h6" style={{ opacity: 0.5 }} align="center" gutterBottom>
            100%
          </Typography>
        </Grid>

        <Grid item xs={6} md>
          <TooltipedText gutterBottom={1} tooltipText={prismicData.tooltip2b.text} position="center">
            <Typography variant="body2" align="center">
              Leads Called
            </Typography>
          </TooltipedText>
          <Typography variant="h5" align="center" gutterBottom>
            50
          </Typography>
          <Typography variant="h6" style={{ opacity: 0.5 }} align="center" gutterBottom>
            50%
          </Typography>
        </Grid>

        <Grid item xs={6} md>
          <TooltipedText gutterBottom={1} tooltipText={prismicData.tooltip2c.text} position="center">
            <Typography variant="body2" align="center">
              Calls Connected
            </Typography>
          </TooltipedText>
          <Typography variant="h5" align="center" gutterBottom>
            25
          </Typography>
          <Typography variant="h6" style={{ opacity: 0.5 }} align="center" gutterBottom>
            20%
          </Typography>
        </Grid>

        <Grid item xs={6} md>
          <TooltipedText gutterBottom={1} tooltipText={prismicData.tooltip2d.text} position="center">
            <Typography variant="body2" align="center">
              Tagged Call
            </Typography>
          </TooltipedText>
          <Typography variant="h5" align="center" gutterBottom>
            25
          </Typography>
          <Typography variant="h6" style={{ opacity: 0.5 }} align="center" gutterBottom>
            20%
          </Typography>
        </Grid>
      </Grid>
    </Tab>
  );
};

const mapStateToProps = ({ me }) => {
  const { overview } = me;
  const { performance } = overview;
  return { ...performance };
};

const mapDispatchToProps = { setTabExpend, setDate };

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(Performance));
